import Slider from "react-slick";
import './index.css';

import {
  QR,
  Container,
  QuestionTitle,
  Bubble,
  Card,
  GridContainer,
  Answer,
  Row2,
} from "./Carousel.styled";


import Q1 from "../../../../static/qr_images/Q1/1.png";
import Q2 from "../../../../static/qr_images/Q1/1.png";
import Q3 from "../../../../static/qr_images/Q1/3.png";
import Q4 from "../../../../static/qr_images/Q2/1.png";
import Q5 from "../../../../static/qr_images/Q2/2.png";
import Q6 from "../../../../static/qr_images/Q2/3.png";
import Q7 from "../../../../static/qr_images/Q3/1.png";
import Q8 from "../../../../static/qr_images/Q3/2.png";
import Q9 from "../../../../static/qr_images/Q3/3.png";
import Q10 from "../../../../static/qr_images/Q4/1.png";
import Q11 from "../../../../static/qr_images/Q4/2.png";
import Q12 from "../../../../static/qr_images/Q4/3.png";
import bubble_path from "../../../../static/qr_images/Bubble.svg";

const QuestionsList = [
  {
    question:
      "How much do you care about improving the quality of your favorite brand?",
    answers: [
      { answer: "I care Alot", QR_path: Q1 },
      { answer: "I kind of care", QR_path: Q2 },
      { answer: "I don’t care at all", QR_path: Q3 },
    ],
  },

  {
    question: "How often do you answer polls and surveys?",
    answers: [
      { answer: "Very often", QR_path: Q4 },
      { answer: "Sometimes", QR_path: Q5 },
      { answer: "I hate them", QR_path: Q6 },
    ],
  },
  {
    question: "Do you like sharing your phone number with your favorite brand?",
    answers: [
      { answer: "I see no problem doing it", QR_path: Q7 },
      { answer: "It bothers a lot", QR_path: Q8 },
      { answer: "I never share my phone number", QR_path: Q9 },
    ],
  },
  {
    question:
      "Does it bother you to share your email address when answering a survey?",
    answers: [
      { answer: "Yes it does", QR_path: Q10 },
      { answer: "Kind of", QR_path: Q11 },
      { answer: "No it doesn’t", QR_path: Q12 },
    ],
  },
];

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style}}
      onClick={onClick}
    />
  );
}


const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  
  return (
    <div
      className={className}
      style={{ ...style}}
      onClick={onClick}
    >
    </div>
  );
}

const Carrousel = () => {  
  
  const settings = {
    dots: true,
    speed: 2000,
    autoplaySpeed: 9000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    fade:true,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <Container>
      <Bubble bubble_path={bubble_path}>
        <h4>Scan me for Voting</h4>
      </Bubble>

      <div style={{padding: '0 10% 0 10%'}}>
        <Slider {...settings}>
          {QuestionsList.map((object, index) => (
            <GridContainer key={index}>
                <QuestionTitle>{object.question}</QuestionTitle>
                <Row2>
                  {object.answers.map((answer, index) => (
                    <Card key={answer.id} id={`card_${index}`}>
                      <QR src={answer.QR_path} />
                      <Answer>{answer.answer}</Answer>
                    </Card>
                  ))}
                </Row2>
            </GridContainer>
          ))}
        </Slider>
      </div>
    </Container>
  );
};

export default Carrousel;
